<template>
  <div id="cobertura">
<div class="col-md-12 flecha-container">  
  <h1 data-aos="fade-up"  data-aos-duration="1500">COBERTURA</h1>
  <img data-aos="fade-right"  data-aos-duration="1500" class="flecha" src="~imgs/icons/Flecha_Negra.png">
  </div>   <div data-aos="fade-right"  data-aos-duration="1500" class="map-container"><img src="~imgs/mapa.png"></div> 
   <div data-aos="zoom-in" style="z-index:2;"  data-aos-duration="1500" class="floating-redbox">
 En A&A buscamos brindar una amplia cobertura en territorio, abarcando estados como: California, Oregón, Arizona y Texas. Nos hemos convertido en un corporativo logístico de importancia, altamente confiable, dispuesto a servir a aquellas empresas que depositan su confianza en nuestras manos. 

</div>
  </div>
</template>

<script>
import Arrow from './reusable/ArrowRight.vue'
export default{
  data(){
    return{

    }
  },
  props:['name', 'selector'],
  components: {
    Arrow
  }
}


</script>

<style lang="scss" scoped>
@import '~varmix';
#cobertura{
  height: 100%;
  height: 100%;
  border-top:30px;
}

.map-container{
  width:80%;
}

.map-container img{
  width:90%;
  z-index:-2;
  position:relative;
  margin-top:-20px;
}
.floating-redbox{
  background-color:$dark-red;
  color:white;
  width:40%;
  min-width:300px;
  padding:80px;
  position:relative;
  float:right;
  margin-top:-30%;
  margin-right:5%;
  z-index:-1;
  box-shadow: 10px 10px 5px #D8D8D8;
  opacity: .8;
    font-size:10pt;

}

.flecha-container{
  width:100%;
  text-align:left;
}
.flecha-container h1{
float:right;
margin-right:20px;
margin-top:20px;

font-size:30pt;
}
.flecha{
margin-left:-30px;
margin-top:20px;
width:80%;
}

@media screen and (max-width: 1200px){
  .floating-redbox{
  font-size:10pt;
    padding:20px;
}
}

@media screen and (max-width: 862px){
.map-container{
  width:100%;
  display:block;
}
.map-container img{
    margin-top:0px;

}

 .floating-redbox{
  
  width:80%;
  margin:auto;
  padding:20px;
  position:relative;
  float:none;
  opacity: 1;
  box-shadow: 0px 0px 0px;
  margin-top:-6px;
  font-size:10pt;
}
}
</style>



// WEBPACK FOOTER //
// cobertura.vue?0d2a9776